import React, { useState } from 'react';
import styled from 'styled-components';
import { EmotionBreakpoint } from 'dw-au-react-components';

const StyledProgressBar = styled.div`
	position: sticky;
	left: 0;
	width: 100%;
	z-index: 1;

	@media (min-width: 1230px) {
		top: 73px;
	}

	@media (max-width: 1229px) {
		top: 53px;
	}

	${EmotionBreakpoint('tablet')} {
		top: 53px;
	}

	${EmotionBreakpoint('mobile')} {
		top: 53px;
	}

	.progress-bar-container {
		background-color: #d9d9d9;
		height: 11px;
	}

	.progress-barr {
		height: 11px;
		transition: width 0.1s ease;
	}
`;

const ProgressBar = () => {
	const [progressWidth, setProgressWidth] = useState(0);

	const pageScroll = () => {
		const winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			oldFooterHeight = document.querySelector('.footer-v2')
				? document.querySelector('.footer-v2').clientHeight
				: 0,
			newFooterHeight = document.getElementById('newFooterReactApp')
				? document.getElementById('newFooterReactApp').clientHeight
				: 0,
			recommenderHeight = document.querySelector('.homepage__recommender')
				? document.querySelector('.homepage__recommender').clientHeight
				: 0,
			footerHeight = newFooterHeight || oldFooterHeight,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight -
				footerHeight -
				recommenderHeight,
			scrolled = (winScroll / height) * 100;
		setProgressWidth(scrolled);
	};

	window.addEventListener('scroll', pageScroll);

	return (
		<StyledProgressBar>
			<div className='progress-bar-container w-100'>
				<div
					className='progress-barr background-red'
					style={{ width: progressWidth > 100 ? '100%' : `${progressWidth}%` }}
				></div>
			</div>
		</StyledProgressBar>
	);
};

export default ProgressBar;
